export default __webpack_public_path__ + "static/media/stripe_logo.750bfde9.png";